export const forbiddenWords = [
    'yo', 'me', 'tú', 'él', 'ella', 'nosotros', 'nos', 'ustedes', 'usted',
    'ellos', 'ellas', 'lo', 'la', 'los', 'las', 'un', 'una', 'el', 'al', 'del',
    'de', 'en', 'con', 'por', 'para', 'que', 'a', 'y', 'ni', 'se', 'es', 'ya',
    'si', 'no', 'hay', 'como', 'fue', 'está', 'soy', 'eres', 'son', 'ha', 'han',
    'hizo', 'tiene', 'tenía', 'estoy', 'karime', 'kari', 'dios', 'thalia',
    'bambi', 'tambor', 'pero', 'bien', 'mal', 'más', 'muy', 'solo', 'todo',
    'así', 'porque', 'siempre', 'ahora', 'antes', 'después'
];
